import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import * as Sentry from '@sentry/browser';
import Icon from '../icon/icon';

export class ErrorBoudaryContent extends Component {
  constructor(props) {
    super(props);
    // Sentry.configureScope(scope => {
    //   scope.setUser(props.profile);
    // });
    Sentry.captureException(new Error(props.error));
  }
  render() {
    return (
      <section className="tc ma3 mw6 flex flex-column center">
        <Icon className="stroke-text center mv4" icon="skull" />
        <h3>Oh no! Something unexpected happened!</h3>
        <p className="mt4">
          Sorry about that. We've captured the error and sent it to the monkeys in the basement. You could either try
          refreshing the page or going back and trying again ¯\_(ツ)_/¯
        </p>
        <div className="flex pt5 center">
          <Button className="mr4" color="primary" outline onClick={() => this.props.history.goBack()}>
            Go back
          </Button>
          <Button outline color="primary" onClick={() => window.location.reload()}>
            Refresh page
          </Button>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    loggedIn: state.auth.profile
  };
}

export default connect(mapStateToProps)(ErrorBoudaryContent);



// WEBPACK FOOTER //
// ./src/components/errorBoundary/content.jsx